var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 56,
    fill: "#FEF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5 32C98.5 31.1716 99.1716 30.5 100 30.5L114 30.5C114.828 30.5 115.5 31.1716 115.5 32C115.5 32.8284 114.828 33.5 114 33.5L100 33.5C99.1716 33.5 98.5 32.8284 98.5 32Z",
    fill: "#F7BA97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 82C1.5 81.1716 2.17157 80.5 3 80.5H17C17.8284 80.5 18.5 81.1716 18.5 82C18.5 82.8284 17.8284 83.5 17 83.5H3C2.17157 83.5 1.5 82.8284 1.5 82Z",
    fill: "#F7BA97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.5 39C104.5 38.1716 105.172 37.5 106 37.5L112 37.5C112.828 37.5 113.5 38.1716 113.5 39C113.5 39.8284 112.828 40.5 112 40.5L106 40.5C105.172 40.5 104.5 39.8284 104.5 39Z",
    fill: "#F7BA97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 89C7.5 88.1716 8.17157 87.5 9 87.5H15C15.8284 87.5 16.5 88.1716 16.5 89C16.5 89.8284 15.8284 90.5 15 90.5H9C8.17157 90.5 7.5 89.8284 7.5 89Z",
    fill: "#F7BA97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.5 32C119.5 31.1716 120.172 30.5 121 30.5H125C125.828 30.5 126.5 31.1716 126.5 32C126.5 32.8284 125.828 33.5 125 33.5H121C120.172 33.5 119.5 32.8284 119.5 32Z",
    fill: "#F7BA97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9653 44.1167C55.4404 44.7953 55.2755 45.7306 54.5969 46.2058C48.3495 50.5803 46.8312 59.191 51.2057 65.4384C51.6809 66.117 51.5159 67.0523 50.8373 67.5275C50.1587 68.0027 49.2234 67.8377 48.7482 67.1591C43.4234 59.5545 45.2716 49.0731 52.8762 43.7483C53.5548 43.2732 54.4901 43.4381 54.9653 44.1167Z",
    fill: "#E9688A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1444 75.9709C89.1237 67.4151 90.75 53.3526 83.4188 42.8826C75.336 31.3393 59.4259 28.5339 47.8826 36.6166C36.3393 44.6994 33.5339 60.6094 41.6166 72.1528C48.9179 82.5802 62.6064 85.8774 73.6935 80.4596C73.7471 80.7118 73.8506 80.9577 74.0068 81.1828L83.0914 94.2794C84.3545 96.1002 86.8572 96.5472 88.6724 95.2761L88.8081 95.1812C90.612 93.918 91.0556 91.4342 89.8004 89.6247L80.7057 76.5136C80.5511 76.2907 80.3592 76.1089 80.1444 75.9709ZM75.4321 75.9613C85.6182 68.8289 88.0937 54.7895 80.9613 44.6033C73.8289 34.4172 59.7895 31.9417 49.6033 39.0741C39.4172 46.2065 36.9417 60.2459 44.0741 70.4321C51.2065 80.6182 65.2459 83.0937 75.4321 75.9613ZM85.5564 92.5695L77.0392 80.291L78.8132 79.0488L87.3354 91.3346C87.6492 91.787 87.5383 92.4079 87.0873 92.7237L86.9517 92.8187C86.4979 93.1364 85.8722 93.0247 85.5564 92.5695Z",
    fill: "#E9688A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchStore);
export default __webpack_public_path__ + "static/media/search_store.2fb68e5d3dfa0e8f9643f329a5f07d7d.svg";
export { ForwardRef as ReactComponent };